import { FC } from 'react';

type Props = {
  size?: number;
  color?: string;
};
const ChatIcon: FC<Props> = ({ size = 30, color = '#596184' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 7.4C17.6314 4.22137 14.5058 2 10.869 2C5.97078 2 2 6.02944 2 11C2 12.7711 2.50412 14.4226 3.37468 15.815L2 20L6.12405 18.605C6.5045 18.85 6.9046 19.0663 7.32139 19.2511"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 28C14.0294 28 10 23.9706 10 19C10 14.0294 14.0294 10 19 10C23.9706 10 28 14.0294 28 19C28 20.7711 27.4884 22.4226 26.605 23.815L28 28L23.815 26.605C22.4226 27.4884 20.7711 28 19 28Z"
      fill={color}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChatIcon;
